/**
 * Extracted from sections/ns-blog-posts.liquid (inline <script> at line 159).
 * Config bridge: window.__nsBlogPostsSections, keyed by section id — the inline block
 * only needed Liquid for the section id, so the id is now handed over as
 * data and the logic runs from a cacheable, deferred asset instead of
 * being parsed and compiled during the HTML parse (INP work on the PDP).
 * Boots once per section id so multiple instances still each initialise.
 */

(function () {
  var cfg = window.__nsBlogPostsSections = window.__nsBlogPostsSections || {};
  function boot(sectionId, settings) {
  function blogPostsLayout () {
    let section = document.querySelector(`#shopify-section-${sectionId}`)
  
    let breakpoint = window.matchMedia('(min-width:700px)');
    let contentContainerEl = section.querySelector('.ns-blog-posts')
    let swiperWrapperEl = section.querySelector('[data-swiper-wrapper]')
    let swiperEl = section.querySelector('[data-swiper-container]')
    let swiperPaginationEl = section.querySelector('.swiper-pagination')

    let readMoreAfterPostsButtonEl = section.querySelector('.ns-blog-posts__after-posts-more-button')
  
    let {
      layoutMobile,
      layoutDesktop,
      itemsPerRowDesktop,
      itemsPerRowMobile,
    } = contentContainerEl.dataset
  
      let blogPostsSwiper
    
      function waitForSwiper(callback) {
        if (typeof Swiper !== 'undefined') {
          callback();
        } else {
          const checkInterval = setInterval(() => {
            if (typeof Swiper !== 'undefined') {
              clearInterval(checkInterval);
              callback();
            }
          }, 100);
        }
      }

      function initializeSwiper () {
        if (blogPostsSwiper) return;
        blogPostsSwiper = new Swiper(swiperEl , {
        slidesPerView: 1.125,
        spaceBetween: 10,
  
        speed: 600,
      
        breakpoints: {
          320: {
            slidesPerView: 1.125,
            spaceBetween: 20
          },
          540: {
            slidesPerView: 1.625,
            spaceBetween: 32
          },
          640: {
            slidesPerView: 1.625,
            spaceBetween: 32
          },
          800: {
            slidesPerView: 2,
            spaceBetween: 32
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 40
          }
        },
    
        autoHeight: true,
      
        navigation: {
          nextEl: section.querySelector('.swiper-button-prev'),
          prevEl: section.querySelector('.swiper-button-next'),
        },
    
        pagination: {
          el: section.querySelector('.swiper-pagination'),
          clickable: true  
        },

        on: {
          init: function () {
            // this.updateAutoHeight();
            // setTimeout(() => {
            //   this.updateAutoHeight();
            // }, 2000);          
            this.pagination.render();
            this.pagination.init();
            this.pagination.update();
          },

        }
      
      })
    }  
  
  
    function destroySwiper() {
        if (typeof blogPostsSwiper !== 'undefined') {
            blogPostsSwiper.destroy(true, true)
        }
    }
    function breakpointChecker(breakpoint) {
        if (breakpoint.matches === true) {
          if (layoutDesktop == 'slider') {
            swiperWrapperEl.style.display = 'flex'
            swiperWrapperEl.classList.add('swiper-wrapper')
            swiperPaginationEl.style.display = 'block'
            waitForSwiper(() => {
              initializeSwiper()
            })

            readMoreAfterPostsButtonEl.style.display = 'flex';
            return
          } else {
            swiperWrapperEl.style.display = 'grid'
            swiperWrapperEl.classList.remove('swiper-wrapper')
            swiperPaginationEl.style.display = 'none'
            destroySwiper();

            swiperWrapperEl.style.display = 'grid'
            readMoreAfterPostsButtonEl.style.display = 'flex';
            return          
          }
        } else if (breakpoint.matches === false) {
          if (layoutMobile == 'slider') {
            swiperWrapperEl.style.display = 'flex';
            swiperWrapperEl.classList.add('swiper-wrapper');
            swiperPaginationEl.style.display = 'block';
            waitForSwiper(() => {
              initializeSwiper();
            })
          
            readMoreAfterPostsButtonEl.style.display = 'none';
            return
          } else {
            swiperWrapperEl.style.display = 'grid'
            swiperWrapperEl.classList.remove('swiper-wrapper')
            swiperPaginationEl.style.display = 'none'
            destroySwiper();
          
            readMoreAfterPostsButtonEl.style.display = 'flex';
            return          
          }
        }
    };
  
  
    breakpointChecker(breakpoint);
    breakpoint.addEventListener("change", () => {
        breakpointChecker(breakpoint)
    })
  
  }

  
  blogPostsLayout()
  
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      blogPostsLayout()
    });
  }
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
